import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Industryusa = () => {
  return (
    <div className="Industry_usa tekrevol_dark_bg  p-100 ">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5}>
            <h2>
              Our Customized <span>Magento Solutions</span> for Specific
              Industries
            </h2>
            <p>
              At TekRevol, our specialty lies in delivering industry-specific
              Magento website development services that precisely match unique
              sector demands. From custom functionalities to captivating
              designs, we cater our services to meet sector-specific
              requirements. That’s how we ensure impactful and specialized
              Magento solutions for businesses across various industries.
            </p>
            <p>
              TekRevol offers its Magento web development services in the
              following industries:
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Build Your Magento Website
            </Link>
          </Col>
          <Col
            xs={12}
            md={4}
            lg={4}
            xl={4}
            xxl={4}
            className="offset-lg-3 offset-md-3 my-auto"
          >
            <div className="industry_scroll">
              <h3>Fintech</h3>
              <h3>Healthcare</h3>
              <h3>E-commerce</h3>
              <h3>Real Estate</h3>
              <h3>Automotive</h3>
              <h3>On-Demand</h3>
              <h3>Education</h3>
              <h3>Music</h3>
              <h3>IT Staff Augmentation</h3>
              <h3>Logistics</h3>
              <h3>Retail</h3>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Industryusa;
